// To add a new hat:
//
// 1. Add the svg component in this folder.
// 2. Make sure it has the marker ref. (see PositionedGoodyHOC.js for details).
// 2. Import the component here.
// 3. Add the goody to `hatOptions` here.
// 4. Add the goody to constants.
// 5. Add a new story in src/stories/hat.js.

import React from 'react';

import PositionedGoodyParentHOC from '../PositionedGoodyParentHOC';

import { POSITIONED_GOODY_REFS } from '../../../../constants';

import PartyHat from './PartyHat';
import Fedora from './Fedora';
import Fez from './Fez';
import Chef from './Chef';
import Baseball from './Baseball';
import Beanie from './Beanie';
import Princess from './Princess';
import King from './King';
import Unicorn from './Unicorn';
import Sweatband from './Sweatband';
import Spinner from './Spinner';
import Bow from './Bow';
import Ranger from './Ranger';
import Sombrero from './Sombrero';
import BeachBall from './BeachBall';
import Witch from './Witch';
import TopHat from './TopHat';
import ShrimponBarbie from './ShrimponBarbie';
// WIP
import FlowerCrown from './FlowerCrown';

const hatOptions = {
	'hat-PartyHat': PartyHat,
	'hat-Fedora': Fedora,
	'hat-Fez': Fez,
	'hat-Chef': Chef,
	'hat-Baseball': Baseball,
	'hat-Beanie': Beanie,
	'hat-Princess': Princess,
	'hat-King': King,
	'hat-Unicorn': Unicorn,
	'hat-Sweatband': Sweatband,
	'hat-Spinner': Spinner,
	'hat-Bow': Bow,
	'hat-Ranger': Ranger,
	'hat-Sombrero': Sombrero,
	'hat-BeachBall': BeachBall,
	'hat-Witch': Witch,
	'hat-TopHat': TopHat,
	'hat-ShrimponBarbie': ShrimponBarbie,
	// WIP
	'hat-FlowerCrown': FlowerCrown,
};

class Hat extends PositionedGoodyParentHOC {
	render() {
		const ThisHat = hatOptions[this.props.goody];

		if (!ThisHat) {
			return null;
		}

		return (
			<svg ref={POSITIONED_GOODY_REFS.GOODY_CONTAINER} {...this.getPosition()}>
				<ThisHat {...this.props} getMarkerCoords={this.getMarkerCoords} />
			</svg>
		);
	}
}

export default Hat;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/_Hat.js